import { defineStore } from "pinia";
import configService from "../services/config.service";

export const useConfigStore = defineStore({
  id: "config",
  state: () => ({
    registration_enabled: false,
    dashboard_text: "",
    login_text: "",
    registration_text: "",
    dietary_enabled: false,
    ticketing_enabled: false,
    guests_enabled: false,
    shift_cancel_notification_time: 0,
    shift_reminder_notification_time: 0,
    arrive_notification_time: 0,
    notify_on_force_assign: false,
    shift_cancel_admin_notification: false,
    hide_tshirts: false,
  }),
  actions: {
    async get() {
      try {
        let res = await configService.get();
        this.registration_enabled = res.data.registration_enabled;
        this.dashboard_text = res.data.dashboard_text;
        this.login_text = res.data.login_text;
        this.registration_text = res.data.registration_text;
        this.dietary_enabled = res.data.dietary_enabled;
        this.guests_enabled = res.data.guests_enabled;
        this.ticketing_enabled = res.data.ticketing_enabled;
        this.shift_cancel_notification_time =
          res.data.shift_cancel_notification_time;
        this.shift_reminder_notification_time =
          res.data.shift_reminder_notification_time;
        this.arrive_notification_time = res.data.arrive_notification_time;
        this.notify_on_force_assign = res.data.notify_on_force_assign;
        this.shift_cancel_admin_notification =
          res.data.shift_cancel_admin_notification;
        this.hide_tshirts = res.data.hide_tshirts;
      } catch (e) {
        console.log(e);
      }
      return {
        registration_enabled: this.registration_enabled,
        registration_text: this.registration_text,
        dashboard_text: this.dashboard_text,
        login_text: this.login_text,
        dietary_enabled: this.dietary_enabled,
        ticketing_enabled: this.ticketing_enabled,
        guests_enabled: this.guests_enabled,
        shift_cancel_notification_time: this.shift_cancel_notification_time,
        shift_reminder_notification_time: this.shift_reminder_notification_time,
        arrive_notification_time: this.arrive_notification_time,
        notify_on_force_assign: this.notify_on_force_assign,
        shift_cancel_admin_notification: this.shift_cancel_admin_notification,
        hide_tshirts: this.hide_tshirts,
      };
    },
    async save(cfg) {
      try {
        let res = await configService.update(cfg);
        this.registration_enabled = res.data.registration_enabled;
        this.dashboard_text = res.data.dashboard_text;
        this.login_text = res.data.login_text;
        this.registration_text = res.data.registration_text;
        this.dietary_enabled = res.data.dietary_enabled;
        this.guests_enabled = res.data.guests_enabled;
        this.ticketing_enabled = res.data.ticketing_enabled;
        this.shift_cancel_notification_time =
          res.data.shift_cancel_notification_time;
        this.shift_reminder_notification_time =
          res.data.shift_reminder_notification_time;
        this.arrive_notification_time = res.data.arrive_notification_time;
        this.notify_on_force_assign = res.data.notify_on_force_assign;
        this.shift_cancel_admin_notification =
          res.data.shift_cancel_admin_notification;
        this.hide_tshirts = res.data.hide_tshirts;
      } catch (e) {
        console.log(e);
      }
    },
  },
});
